import React from 'react'
import {Table} from 'reactstrap';
export default props => {
    return (
        <Table responsive striped>
            <thead>
                <tr>
                    {props.headers.map((header, index) => <th key={index}>{header}</th>)}
                </tr>
            </thead>
            <tbody>
                {props.getRows()}
            </tbody>
        </Table>
    )
}


// WEBPACK FOOTER //
// ./src/views/components/table/Table.js